import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['modal', 'step', 'dot', 'backButton', 'nextButton', 'doneButton'];

  get totalSteps() {
    return this.stepTargets.length;
  }

  open() {
    this.currentStep = 0;

    this.stepTargets.forEach((step, index) => {
      step.classList.toggle('hidden', index !== 0);
    });

    if (this.hasDotTarget) {
      this.dotTargets.forEach((dot, index) => {
        dot.classList.toggle('bg-gray-900', index === 0);
        dot.classList.toggle('bg-gray-300', index !== 0);
      });
    }

    this.updateNavigation();
    this.modalTarget.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    if (this.modalTarget.classList.contains('hidden')) return;

    this.modalTarget.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
  }

  back() {
    if (this.currentStep > 0) this.goTo(this.currentStep - 1);
  }

  next() {
    if (this.currentStep < this.totalSteps - 1) this.goTo(this.currentStep + 1);
  }

  goTo(index) {
    this.stepTargets[this.currentStep].classList.add('hidden');

    if (this.hasDotTarget) {
      this.dotTargets[this.currentStep].classList.replace('bg-gray-900', 'bg-gray-300');
      this.dotTargets[index].classList.replace('bg-gray-300', 'bg-gray-900');
    }

    this.currentStep = index;
    this.stepTargets[this.currentStep].classList.remove('hidden');
    this.updateNavigation();
  }

  updateNavigation() {
    const isFirst = this.currentStep === 0;
    const isLast = this.currentStep === this.totalSteps - 1;

    if (this.hasBackButtonTarget) {
      this.backButtonTarget.classList.toggle('hidden', isFirst);
    }
    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.classList.toggle('hidden', isLast);
    }
    if (this.hasDoneButtonTarget) {
      this.doneButtonTarget.classList.toggle('hidden', !isLast);
    }
  }
}
